module.exports = __webpack_public_path__ + "static/media/male.06d19560.svg";